var Portfolio = require('models/portfolio');

var EnrollmentDataService = require('services/enrollment-data-service');
var CourseSettingsService = require('services/course-settings-service');
var ContentService = require('services/content-service');

var PortfolioService = function() {
  if (PortfolioService.prototype._singleton){
    return PortfolioService.prototype._singleton;
  }

  PortfolioService.prototype._singleton = this;

  this.initialize = function(){
    this.portfolio = new Portfolio();
    this.portfolio.set(CourseSettingsService.get('portfolio'));
    ContentService.applyContent(this.portfolio, 'portfolio');

    _.each(this.portfolio.get('contents'), function(item) {
      if (item.type === 'checklist'){
        var items = [];
        _.each(item.items, function(moduleItems, moduleKey) {
          _.each(moduleItems, function(moduleItem){
            moduleItem.module_key = moduleKey;
          });
          items = items.concat(moduleItems);
        });
        item.items = items;
      }
    });

    var userData =  EnrollmentDataService.getData('portfolio_data') || {};
    var self = this;
    if (userData){
      _.each(userData,function(data, key){
        var content = self.portfolio.get('contents')[key];
        if (content && content.type === 'checklist'){
          _.each(data, function(value, item){
            if (item === 'custom_items' && content.allow_custom){
              content.items = content.items.concat(value);
            } else if(item === 'other-field') {
              content.other_item = value;
            } else {
              var contentItem = _.find(content.items, { key: item });
              if(contentItem)
                contentItem.checked = value;
            }
          });
        }
      });
    }
    this.portfolio.set('user_data', userData);
  };
  this.getPortfolioViewOptions = function(defaults){
    var contents = _.map(this.portfolio.get('contents'), function(item, key) {
      item.key = key;
      return item;
    });

    var options = {
      model: this.portfolio,
      collection: new Chaplin.Collection(contents)
    };

    return _.defaults(options, defaults);
  };
  this.getChecklist = function(checklistKey){
    return this.portfolio.get('contents')[checklistKey];
  };
  this.setChecklistItemValue = function(checklistKey, itemKey, value){
    var userData = this.portfolio.get('user_data');
    if (!userData[checklistKey]){
      userData[checklistKey] = {};
    }
    userData[checklistKey][itemKey] = value;

    var item = _.find(this.portfolio.get('contents')[checklistKey].items, { key: itemKey });

    if(item !== undefined) {
      item.checked = value;
    }

    EnrollmentDataService.saveData('portfolio_data', userData);
  };
  this.addCustomChecklistItem = function(checklistKey, text){
    var userData = this.portfolio.get('user_data');
    if (!userData[checklistKey]){
      userData[checklistKey] = {};
    }
    var id = 0;
    if (!userData[checklistKey].custom_items){
      userData[checklistKey].custom_items = [];
    } else {
      var items = userData[checklistKey].custom_items;
      if (items.length > 0) {
        id = items[items.length - 1].id + 1;
      }
    }

    var item = {
      checked: true,
      custom: true,
      id: id,
      key: 'custom-item-' + id,
      module_key: EF.module.get('key'),
      page_key: EF.module.currentActivity.currentPage.get('key'),
      action_tip: 'User Created Item',   //TODO:  translate this....
      text: text
    };

    userData[checklistKey].custom_items.push(item);
    this.portfolio.get('contents')[checklistKey].items.push(item);
    EnrollmentDataService.saveData('portfolio_data', userData);
  };

  this.addOtherChecklistItem = function(checklistKey, text) {
    var userData = this.portfolio.get('user_data');
    if (!userData[checklistKey]){
      userData[checklistKey] = {};
    }

    var item = {
      checked: true,
      other: true,
      key: 'other-item',
      module_key: EF.module.get('key'),
      page_key: EF.module.currentActivity.currentPage.get('key'),
      text: text
    };

    userData[checklistKey]['other-field'] = item;
    let checklist = this.getChecklist(checklistKey);
    checklist.other_item = item;
    EnrollmentDataService.saveData('portfolio_data', userData);
  };

  this.deleteCustomChecklistItem = function(checklistKey, itemKey) {
    var userData = this.portfolio.get('user_data');
    userData[checklistKey].custom_items = _.reject(userData[checklistKey].custom_items, { key: itemKey });
    this.portfolio.get('contents')[checklistKey].items = _.reject(this.portfolio.get('contents')[checklistKey].items, { key: itemKey });

    EnrollmentDataService.saveData('portfolio_data', userData);
  };
};

module.exports = new PortfolioService();
